(() => {
  const READY_CLASS = 'header-contrast-ready';
  const SCROLLED_CLASS = 'header-scrolled';
  const DROPDOWN_CLASS = 'has-dropdown-menu';
  const HEADER_POPUP_CLASS = 'has-header-popup';
  const TRANSPARENT_CLASS = 'trc-transparent-header';
  const MENU_DRAWER_OPEN_CLASS = 'trc-menu-drawer-open';
  const BACKGROUND_TRANSITION_MS = 650;

  const init = () => {
    const section = document.querySelector('.header-section');
    const header = section?.querySelector('.header--transparent');
    if (!section || !header) return;

    const gradient = document.createElement('div');
    gradient.className = 'trc-header-gradient no-empty';
    gradient.setAttribute('aria-hidden', 'true');
    section.before(gradient);

    let timer;
    let transitionHandler;

    // Classes that stand in for the :has() selectors in theme.css and
    // trc-header-auto-contrast.css (Safari 15.3 and older has no :has()).
    section.classList.add(TRANSPARENT_CLASS);

    const isPopupOpen = () => {
      const drawerOpen = Boolean(section.querySelector('.menu-drawer[open]'));
      section.classList.toggle(MENU_DRAWER_OPEN_CLASS, drawerOpen);
      return document.body.classList.contains(DROPDOWN_CLASS) ||
        document.body.classList.contains(HEADER_POPUP_CLASS) ||
        drawerOpen;
    };

    const isBlocked = () => {
      const popupOpen = isPopupOpen();
      return section.classList.contains(SCROLLED_CLASS) || popupOpen;
    };

    let blocked = isBlocked();

    const cancelPendingEnable = () => {
      window.clearTimeout(timer);
      timer = undefined;
      if (transitionHandler) {
        header.removeEventListener('transitionend', transitionHandler);
        transitionHandler = undefined;
      }
    };

    const enable = () => {
      cancelPendingEnable();
      if (!isBlocked()) section.classList.add(READY_CLASS);
    };

    const enableAfterBackgroundFade = () => {
      cancelPendingEnable();
      section.classList.remove(READY_CLASS);

      if (!window.matchMedia('(pointer: fine)').matches) {
        enable();
        return;
      }

      transitionHandler = (event) => {
        if (event.target === header && event.propertyName === 'opacity' && event.pseudoElement === '::before') {
          enable();
        }
      };
      header.addEventListener('transitionend', transitionHandler);
      timer = window.setTimeout(enable, BACKGROUND_TRANSITION_MS);
    };

    const sync = (initial = false) => {
      const nextBlocked = isBlocked();
      if (!initial && nextBlocked === blocked) return;
      blocked = nextBlocked;

      if (blocked) {
        cancelPendingEnable();
        section.classList.remove(READY_CLASS);
      } else if (initial) {
        section.classList.add(READY_CLASS);
      } else {
        enableAfterBackgroundFade();
      }
    };

    new MutationObserver(() => sync()).observe(section, {
      attributes: true,
      attributeFilter: ['class'],
    });
    const menuDrawer = section.querySelector('.menu-drawer');
    if (menuDrawer) {
      new MutationObserver(() => sync()).observe(menuDrawer, {
        attributes: true,
        attributeFilter: ['open'],
      });
    }
    new MutationObserver(() => sync()).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    const account = section.querySelector('shopify-account');
    const uploadPanel = section.querySelector('[data-trc-upload-panel]');
    let accountDialogOpen = false;
    let uploadPanelOpen = Boolean(uploadPanel && !uploadPanel.hidden);

    const syncHeaderPopup = () => {
      document.body.classList.toggle(HEADER_POPUP_CLASS, accountDialogOpen || uploadPanelOpen);
    };

    const setAccountDialogOpen = (open) => {
      accountDialogOpen = Boolean(open);
      syncHeaderPopup();
    };

    const watchAccountDialog = (attempt = 0) => {
      const shadow = account?.shadowRoot;
      if (!shadow) {
        if (account && attempt < 20) window.setTimeout(() => watchAccountDialog(attempt + 1), 50);
        return;
      }

      const syncAccountDialog = () => {
        setAccountDialogOpen(Boolean(shadow.querySelector('dialog[open]')));
      };
      new MutationObserver(syncAccountDialog).observe(shadow, {
        subtree: true,
        attributes: true,
        attributeFilter: ['open'],
      });
      syncAccountDialog();
    };

    if (account) {
      account.addEventListener('open', () => setAccountDialogOpen(true));
      account.addEventListener('close', () => setAccountDialogOpen(false));
      customElements.whenDefined('shopify-account').then(() => watchAccountDialog());
    }

    if (uploadPanel) {
      const syncUploadPanel = () => {
        uploadPanelOpen = !uploadPanel.hidden;
        syncHeaderPopup();
      };
      new MutationObserver(syncUploadPanel).observe(uploadPanel, {
        attributes: true,
        attributeFilter: ['hidden'],
      });
      syncUploadPanel();
    } else {
      syncHeaderPopup();
    }

    sync(true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
